import script from "./ArticleChapterLink.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticleChapterLink.vue?vue&type=script&setup=true&lang=js"

import "./ArticleChapterLink.vue?vue&type=style&index=0&id=b031ce64&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/gs-webex-sys/gs-webex-sys/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b031ce64"]])

export default __exports__